<script setup lang="ts">
import CustomIncrement from "@/components/CustomIncrement/CustomIncrement.vue";
import {computed, reactive, ref, watch} from "vue";
import {useI18n} from "vue-i18n";
import * as Passengers from "@/components/BookingComponent/composables/passengers";
import {useMatches} from "vue-responsiveness";
import QueryBuilder from "@/models/Query";

const {t} = useI18n();
const matches = useMatches()

const passengers = defineModel('passengers', {default: 0});
const cabins = defineModel('cabins', {default: [0,0]});
const skipper = defineModel('skipper', {default: false})

const open = ref(false);
const usePassengers = reactive(Passengers.usePassengers())
const inputWidth = computed(() => matches.isMin('min') ? 'w-full' : 'w-[11vw]');


watch(usePassengers, (newValue) => {
  passengers.value = newValue.passengers;
  cabins.value = [newValue.cabins,QueryBuilder.MAX];
  skipper.value = newValue.skipper;
})

watch([passengers,cabins,skipper], ([newPassenger,newCabin,newSkipper]) => {
  usePassengers.passengers = newPassenger;
  usePassengers.cabins = newCabin[0];
  usePassengers.skipper = newSkipper;
})


</script>

<template>
  <div class="relative flex">
    <VTextField variant="underlined"
                :model-value="usePassengers.text"
                placeholder="Any Number"
                readonly
                :class="inputWidth"
                @click="open = !open
">
      <template #prepend-inner>
        <img src="@/assets/icons/svg/Guest_16x16.svg" :alt="t('passengers')" class="min-w-5"/>
      </template>
    </VTextField>
    <div v-if="open" v-click-outside="() => open = false"
         class="shadow-2xl absolute top-full h-fit left-0 w-[26rem] bg-white flex flex-col gap-3 justify-center items-center py-5 px-6 z-[2001]">
      <div class="flex items-center justify-between w-full">
        <div>{{ t('passengers') }}</div>
          <CustomIncrement :value="usePassengers.passengers"
                           @increment="usePassengers.incrementPassenger"
                           @decrement="usePassengers.decrementPassenger"/>
      </div>
      <div class="flex items-center justify-between w-full">
        <div>{{ t('cabins') }}</div>
          <CustomIncrement :value="usePassengers.cabins"
                           @increment="usePassengers.incrementCabin"
                           @decrement="usePassengers.decrementCabin"/>
      </div>
      <div class="w-full flex flex-row justify-between items-end">
        <div class="flex flex-col items-start justify-between w-full">
          <div>{{ t('skipper') }}</div>
          <div class=" responsive-body-small text-black/40">{{ t('skipper_info') }}</div>
        </div>
        <VSwitch inset v-model="usePassengers.skipper" base-color="grey" color="black"></VSwitch>
      </div>
    </div>
  </div>
</template>

<style scoped>
:deep(.v-switch__track) {
  opacity: 1;
}
</style>
